import { useState } from "react";
import { hotWords } from "@/mocks/gossip";

export default function Hero() {
  const [kw, setKw] = useState("");

  const submit = () => {
    if (kw.trim()) {
      document.getElementById("feed")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const pick = (w: string) => {
    setKw(w);
    document.getElementById("feed")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=playful%20abstract%20watermelon%20and%20melon%20illustration%20background%20with%20soft%20coral%20pink%20and%20cream%20blobs%20cute%20floating%20fruit%20shapes%20memes%20stickers%20bubbles%20bright%20cheerful%20flat%20vector%20art%20modern%20fun%20fresh%20summer%20vibe&width=1600&height=900&seq=hero-bg&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-500/40 via-primary-500/10 to-background-50"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-6xl flex-col items-center px-4 pb-20 pt-32 text-center md:px-6 md:pb-28 md:pt-44">
        <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50/85 px-4 py-1.5 text-xs font-semibold text-primary-600 shadow-soft">
          <i className="ri-fire-fill"></i>
          全网最有才的吃瓜群众都在这
        </span>

        <h1 className="mt-6 max-w-3xl text-balance font-display text-4xl font-black leading-tight text-background-50 md:text-6xl">
          看热闹？更要看评论
        </h1>
        <p className="mt-5 max-w-2xl text-sm leading-7 text-background-50/95 md:text-base">
          神回复、沙雕段子、梗图表情包一网打尽。这里汇聚网友高能热评，弹幕表情包齐飞，让你一次笑个痛快、瓜吃到扶墙。
        </p>

        <div className="mt-8 flex w-full max-w-xl flex-col gap-3 sm:flex-row">
          <div className="flex flex-1 items-center gap-2 rounded-full bg-background-50 px-5 py-3 shadow-soft">
            <i className="ri-search-line text-lg text-primary-500"></i>
            <input
              value={kw}
              onChange={(e) => setKw(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && submit()}
              placeholder="搜个梗、找张表情包试试"
              className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
              aria-label="搜索梗与表情包"
            />
          </div>
          <button
            onClick={submit}
            className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-all hover:bg-primary-600"
          >
            开吃
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-2">
          <span className="whitespace-nowrap text-xs font-medium text-background-50/85">
            今日热梗：
          </span>
          {hotWords.map((w) => (
            <button
              key={w}
              onClick={() => pick(w)}
              className="cursor-pointer whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/20 px-3 py-1 text-xs font-medium text-background-50 transition-colors hover:bg-background-50 hover:text-primary-600"
            >
              #{w}
            </button>
          ))}
        </div>

        <div className="mt-12 grid w-full max-w-3xl grid-cols-3 gap-3 md:gap-6">
          {[
            { num: "100万+", label: "精选热评" },
            { num: "38万+", label: "神回复收藏" },
            { num: "99%", label: "用户每天笑到劈叉" },
          ].map((s, i) => (
            <div
              key={i}
              className="rounded-2xl border border-background-50/20 bg-background-50/70 px-3 py-4 text-center backdrop-blur-sm"
            >
              <p className="font-display text-xl font-black text-primary-600 md:text-2xl">{s.num}</p>
              <p className="mt-1 whitespace-nowrap text-[11px] font-medium text-foreground-600 md:text-xs">
                {s.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}